export const checkboxHandler = (checkbox, cb = null) => {
  if (!checkbox) return;

  const checkboxInput = checkbox.querySelector('input');
  const checkboxField = checkbox.querySelector('span');

  if (!checkboxInput) return;

  let initialValue = Boolean(checkboxInput.hasAttribute('checked'));

  checkboxInput.value = initialValue ? 'on' : 'off';

  const onCheck = () => {
    initialValue = !initialValue;
    initialValue
      ? checkboxInput.setAttribute('checked', '')
      : checkboxInput.removeAttribute('checked');
    checkboxInput.value = initialValue ? 'on' : 'off';

    cb?.(initialValue);
  };

  checkboxInput.addEventListener('click', onCheck);

  checkboxField.addEventListener('keyup', (e) => {

    if (e.key === 'Enter' || e.key === '') {
      onCheck();
    }
  });
};
